import { useReducer } from "react";

type State<TData extends object> =
  | { data: undefined; isOpen: false }
  | { data: TData; isOpen: true };

type Action<TData> = { type: "SHOW"; data: TData } | { type: "HIDE" };

type UseConfirmSubmit<TData extends object> = State<TData> & {
  open: (data: TData) => void;
  close: () => void;
};

const reducer = <TData extends object>(
  state: State<TData>,
  action: Action<TData>,
): State<TData> => {
  switch (action.type) {
    case "SHOW": {
      return { ...state, data: action.data, isOpen: true };
    }
    case "HIDE": {
      return { ...state, data: undefined, isOpen: false };
    }
    default: {
      return state;
    }
  }
};

const initialState: State<any> = { data: undefined, isOpen: false };

export const useConfirmSubmit = <
  TData extends object,
>(): UseConfirmSubmit<TData> => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const open = (data: TData) => dispatch({ type: "SHOW", data });
  const close = () => dispatch({ type: "HIDE" });

  return { ...state, open, close } as UseConfirmSubmit<TData>;
};
